<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="device_id detail_content">
            <div class="device_id_label detail_label">
              {{ deviceIdLabel }}
            </div>
            <div id="device_id">
              {{ device.deviceId }}
            </div>
          </div>
          <div class="device_name detail_content">
            <div class="device_name_label detail_label">
              {{ deviceNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="device.deviceName"
              @input="inputUpdate('deviceName')"
            />
          </div>
          <div class="phone_number detail_content">
            <div class="phone_number_label detail_label">
              {{ phoneNumberLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="device.phoneNumber2"
              @input="inputUpdate('phoneNumber')"
            />
          </div>
          <div class="create_date_time detail_content">
            <div class="create_date_time_label detail_label">
              {{ createDateTimeLabel }}
            </div>
            <div class="create_date_time">
              {{ device.createDateTime }}
            </div>
          </div>
          <div class="last_update_date_time detail_content">
            <div class="last_update_date_time_label detail_label">
              {{ lastUpdateDateTimeLabel }}
            </div>
            <div class="last_update_date_time">
              {{ device.lastUpdateDateTime }}
            </div>
          </div>
          <div class="user_id detail_content">
            <div class="user_id_label detail_label">
              {{ userIdLabel }}
            </div>
            <div class="user_id">
              {{ device.userId }}
            </div>
          </div>
          <div class="user_name detail_content">
            <div class="user_name_label detail_label">
              {{ userNameLabel }}
            </div>
            <div class="user_name">
              {{ device.userName }}
            </div>
          </div>
          <div class="personal_device_flag detail_content">
            <div class="personal_device_flag_label detail_label">
              {{ personalDeviceFlagLabel }}
            </div>
            <div class="device_radio_buttons">
              <label>
                <input
                  type="radio"
                  class="device_radio_button"
                  name="personal_device_flag"
                  value="true"
                  :checked="checked"
                  @click="checkedAction()"
                />
                {{ personalDeviceTrueLabel }}
              </label>
              <label>
                <input
                  type="radio"
                  class="device_radio_button"
                  name="personal_device_flag"
                  value="false"
                  :checked="!checked"
                  @click="checkedAction()"
                />
                {{ personalDeviceFalseLabel }}
              </label>
            </div>
          </div>
          <div class="call_app_division detail_content">
            <div class="call_app_label detail_label">
              {{ callAppLabel }}
            </div>
            <select
              class="drop_down_list"
              @change="inputUpdate('callAppDivision')"
            >
              <option disabled selected value="">{{
                callAppList[indexOfCallAppList].callAppName
              }}</option>
              <option
                v-for="callApp in callAppList"
                :value="callApp.id"
                :key="callApp.id"
              >
                {{ callApp.callAppName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showModal = true"
        />
      </div>
      <div class="modal_window" v-if="showModal">
        <modalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </modalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import modalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      deviceNameLabel: '端末名',
      deviceIdLabel: '端末ID',
      phoneNumberLabel: '電話番号',
      createDateTimeLabel: '登録日時',
      lastUpdateDateTimeLabel: '最終アクセス',
      userNameLabel: 'ログインユーザ名',
      userIdLabel: 'ログインユーザID',
      personalDeviceFlagLabel: '使用用途',
      personalDeviceTrueLabel: '個人端末',
      personalDeviceFalseLabel: '共用端末',
      callAppLabel: '連携アプリ',
      router: '/devices',
      deleteWord: 'この情報を削除してよろしいですか？',
      checked: '',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    device() {
      return this.$store.state.devices.device
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    callAppList() {
      return this.$store.state.masters.masterData.callAppList
    },
    indexOfCallAppList() {
      for (
        let i = 0;
        i < this.$store.state.masters.masterData.callAppList.length;
        i++
      ) {
        if (
          this.$store.state.masters.masterData.callAppList[i].id ===
          this.device.callAppDivision
        ) {
          return i
        }
      }
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  created() {
    this.checked = this.$store.state.devices.device.personalDeviceFlag
  },
  components: {
    modalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    checkedAction(e) {
      this.checked = !this.checked
    },
    inputUpdate(e) {
      this.$store.dispatch('devices/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'devices/setDetailDevice',
          this.$store.state.devices.device
        )
        this.$router.push('../devices/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_160001
        let eventType = 3
        let reason = 'MSGCRC0018 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0018.name +
            this.errorMsg.MSGCRC0018.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      let personalDeviceFlags = document.getElementsByName(
        'personal_device_flag'
      )
      let personalDeviceFlag
      for (let i = 0; i < personalDeviceFlags.length; i++) {
        if (personalDeviceFlags[i].checked) {
          /** 文字列になるためboolで格納 */
          if (personalDeviceFlags[i].value === 'true') {
            personalDeviceFlag = true
          } else {
            personalDeviceFlag = false
          }
          break
        }
      }
      this.$store.dispatch(
        'devices/changePersonalDeviceFlag',
        personalDeviceFlag
      )
      try {
        await this.$store.dispatch('devices/updateDevice')
        this.$emit('list-reload')
        if (location.pathname !== '/devices/detail') {
          this.$router.push('../devices/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_160003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0014') {
            this.failureWord =
              this.errorMsg.MSGCRC0014.name +
              this.errorMsg.MSGCRC0014.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0015') {
            this.failureWord =
              this.errorMsg.MSGCRC0015.name +
              this.errorMsg.MSGCRC0015.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0092') {
            this.failureWord =
              this.errorMsg.MSGCRC0092.name +
              this.errorMsg.MSGCRC0092.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0097') {
            this.failureWord =
              this.errorMsg.MSGCRC0097.name +
              this.errorMsg.MSGCRC0097.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0098') {
            this.failureWord =
              this.errorMsg.MSGCRC0098.name +
              this.errorMsg.MSGCRC0098.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0121') {
            this.failureWord =
              this.errorMsg.MSGCRC0121.name +
              this.errorMsg.MSGCRC0121.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0124') {
            this.failureWord =
              this.errorMsg.MSGCRC0124.name +
              this.errorMsg.MSGCRC0124.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0019.name +
              this.errorMsg.MSGCRC0019.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0019'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0019.name +
            this.errorMsg.MSGCRC0019.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'devices/setDetailDevice',
          this.$store.state.devices.device
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_160002
        let eventType = 3
        let reason = 'MSGCRC0018 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0018.name +
            this.errorMsg.MSGCRC0018.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let deviceId = this.$store.state.devices.device.deviceId
      let deleteList = [{deviceId}]
      try {
        await this.$store.dispatch('devices/deleteDevices', deleteList)
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_160004
        let eventType = 3

        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0020') {
            this.failureWord =
              this.errorMsg.MSGCRC0020.name +
              this.errorMsg.MSGCRC0020.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/deviceEdit.vue